import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const params = new URLSearchParams(useLocation().search);
  const resultId = params.get("result_id");

  return (
    <div className="relative z-10 mx-auto min-h-[100dvh] w-full max-w-md px-6 py-20 text-center" data-testid="payment-cancel-screen">
      <SEOHead noindex path="/payment/cancel" title="Payment cancelled" />
      <p className="text-[11px] font-medium uppercase" style={{ color: "var(--muted)", letterSpacing: "0.32em" }}>
        Payment cancelled
      </p>
      <h1 className="mt-3 font-serif text-[36px]" style={{ color: "var(--gold)" }}>
        No charge was made.
      </h1>
      <p className="mt-4 text-[15px]" style={{ color: "var(--text)" }}>
        Your result is still available. You can unlock the full report anytime.
      </p>
      <div className="mt-10 flex flex-col gap-3">
        <button
          className="btn-primary"
          onClick={() => (resultId ? navigate(`/result/${resultId}`) : navigate("/"))}
          data-testid="back-to-result-btn"
        >
          Back to my result
        </button>
      </div>
      <Footer />
    </div>
  );
}
